import { render } from "./homeStudioNews.vue?vue&type=template&id=60ad37b5&scoped=true"
import script from "./homeStudioNews.vue?vue&type=script&lang=js"
export * from "./homeStudioNews.vue?vue&type=script&lang=js"

import "./homeStudioNews.vue?vue&type=style&index=0&id=60ad37b5&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ad37b5"]])

export default __exports__